import { useCallback } from 'react'
import {
  getReceivablesRiskAnalysisReport,
  type ReceivablesRiskAnalysisReportResult,
  type ReportBucketType,
} from '@services/api/reports/finance.api'
import { useFinanceReportQuery } from '@hooks/reports/useFinanceReportQuery'

export type ReceivablesRiskFinanceData = ReceivablesRiskAnalysisReportResult

export type UseReceivablesRiskFinanceResult = {
  loading: boolean
  error: string | null
  data: ReceivablesRiskFinanceData | null
  bucketLabel: string
}

export function useReceivablesRiskFinance(
  toolbarSelection: Record<string, string>,
): UseReceivablesRiskFinanceResult {
  const getBucketFromData = useCallback(
    (data: ReceivablesRiskAnalysisReportResult): ReportBucketType =>
      data.arTrendByPeriod.bucket,
    [],
  )

  return useFinanceReportQuery({
    toolbarSelection,
    fetchReport: getReceivablesRiskAnalysisReport,
    getBucketFromData,
    errorMessage: 'Failed to load receivables risk data',
  })
}
